import { IEnvironmentModel } from './environment.model';

export const localEnvironment: IEnvironmentModel = {
  type: 'local',
  production: false,
  dev: false,
  domain: 'local.di.hrm.stag.visma.net',

  // logging
  enableBrowserLogs: false,
  enableRUM: false,

  // authentication and client IDs
  dummyAuth: false,
  signinUrl: 'https://signin.stag.visma.net/loginwebapp',
  loginRedirectUrl: 'https://local.di.hrm.stag.visma.net:4200',
  oauth: {
    issuer: 'https://connect.identity.stagaws.visma.com',
    clientId: 'VismaNetHrmDataImport',
  },
  ldClientSideID: '60864544e6fcb90ba6496233', // Local key
  wootricAccountToken: null,

  // APIs
  dataImportApiBaseUrl: '/api',
  staticJsonApiBaseUrl: 'https://static-json.no.stag.visma.net/',
  wsBaseUrl: 'wss://ws.di.hrm.stag.visma.net',

  // external links
  empManModuleId: 4742422,
  vismaHomeUrl: 'https://home.stag.visma.com/',
  vismaEmpmanUrl: 'https://web.employeecore1.hrm.stag.visma.net/uiempmanapp/',
  vismaAboutUrl: 'https://wagerun.cj.hrm.stag.visma.net/',
  vismaCalendarUrl: 'https://web.calendar.hrm.stag.visma.net/',
  payrollUiUrl: 'https://payrollui.no.stag.visma.net/',
  payrollPortal:
    'https://web.calendar.hrm.stag.visma.net/absence/_Svelte/dist/scripts/es/ClientPortalComponentProvider.js',
  wagerunUrl: 'https://wagerun.cj.hrm.stag.visma.net',
  accountSettingsUrl: 'https://accountsettings.connect.identity.stagaws.visma.com/',

  // embedded components
  timeDocumentsUrl: '/timeui/dist/clientportal-component-provider.js',
  variableTransactionsUrl: '/wagerun/componentProviders/employeeTransactionsProviderV1.js',
  assistant: {
    apiBaseUrl: 'https://api.assistant.stag.vsn.dev',
    profileId: 'payroll-prod',
  },
  walkmeSrc:
    'https://eu-cdn.walkme.com/users/156f0c8fa19a4b7cbd7437d888ce43cc/test/walkme_private_156f0c8fa19a4b7cbd7437d888ce43cc_https.js',
  walkmeIntegrity: 'sha256-xA7YXeCjh992RrqQgJYVJkaC1WKs0iPQ4lE/tNN65b4=',
};
